import granada121 from "./granada12-1.webp";
import granada122 from "./granada12-2.webp";

const granada12 = [granada121, granada122];

export default granada12;
